import { render } from "./IMultiPicker.vue?vue&type=template&id=0b812628"
import script from "./IMultiPicker.vue?vue&type=script&lang=js"
export * from "./IMultiPicker.vue?vue&type=script&lang=js"

import "./IMultiPicker.vue?vue&type=style&index=0&id=0b812628&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__